import { applyMiddleware } from 'redux'
import { apiMiddleware } from 'redux-api-middleware'
import thunk from 'redux-thunk'
import { apiMockup, appendApiHeaders } from 'sidecar-utility-library'
import { createCacheMiddleware } from 'sidecar-utilities'

import { handleAuth, handleLogout } from './authentication'
import handleErrors from './handleErrors'
import handleFetchAccountMetadata from './handleFetchAccountMetadata'
import handleValidateAccount from './handleValidateAccount'
import { hydrateIpInfo, storeIpInfo } from './ipInfo'
import {
  addHeapUserProperties,
  addWebMessengerUserProperties,
  handleCancellation,
  getRatingArea,
  handleAuthedUser,
  handleMemberAppSession,
} from './memberMiddleware'
import reportErrors from './reportErrors'
import supportTraceId from './supportTraceId'
import unauthorized from './unauthorized'
import {
  getCareSearchPreCheckProviders,
  addPreCheckedProviderHeapEvent,
  addPreCheckedCareSearchHeapEvent,
  preParseCareDetail,
} from './careMiddleware'
import { downloadAttachment } from './downloadAttachment'
import { typeScraper, responseScraper } from './apiScraper'
import { handleAddressVerification } from './address'
import { addStateToAction } from './addStateToAction'
import endpointInterceptor from './endpointInterceptor'

// createCacheMiddleware is a factory that returns to us a couple
// of middleware functions we need to put in different spots.
const { readCache, recordCache } = createCacheMiddleware()

export const middleware = [
  typeScraper,
  apiMockup,
  appendApiHeaders,
  readCache, // MUST come BEFORE we make the call with apiMiddleware
  endpointInterceptor,
  supportTraceId,
  // everything above this line has an opportunity
  // to modify the RSAA before anything happens.
  // It's not clear if thunks below this line have any specific order.
  apiMiddleware,
  addStateToAction,
  responseScraper,
  recordCache, // MUST come AFTER we make the call with apiMiddleware
  unauthorized,
  handleFetchAccountMetadata,
  getRatingArea,
  handleValidateAccount,
  storeIpInfo,
  hydrateIpInfo,
  handleAddressVerification,
  handleCancellation,
  addPreCheckedProviderHeapEvent,
  addPreCheckedCareSearchHeapEvent,
  addHeapUserProperties,
  addWebMessengerUserProperties,
  handleMemberAppSession,
  handleAuthedUser,
  reportErrors,
  handleErrors,
  thunk,
  handleAuth,
  handleLogout,
  getCareSearchPreCheckProviders,
  downloadAttachment,
  preParseCareDetail,
]

export default applyMiddleware(...middleware)
